import React from 'react';
import { motion } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      role: "CTO, TechVision India",
      content: "PlatypusBox delivered exceptional results for our AI-driven platform. Their expertise in cutting-edge technologies and understanding of the Indian market made them the perfect partner.",
      rating: 5
    },
    {
      name: "Priya Sharma",
      role: "Founder, InnovateHub Bangalore",
      content: "Their team's dedication to quality and innovation is remarkable. They transformed our startup's digital presence while keeping our unique Indian identity intact.",
      rating: 5
    },
    {
      name: "Amit Patel",
      role: "Director, Digital Solutions Mumbai",
      content: "Working with PlatypusBox was a game-changer for our business. They understood our requirements perfectly and delivered a solution that exceeded our expectations.",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="relative min-h-screen bg-forest overflow-hidden">
      {/* Diagonal split overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-forest" />
        <div 
          className="absolute inset-0 bg-[#3D2314] transform -skew-y-6 origin-top-right"
          style={{ top: '40%' }}
        />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-20">
        <motion.h2 
          className="text-6xl font-bold text-center mb-20 text-accent-green"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Client Testimonials
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-forest/30 backdrop-blur-sm p-8 rounded-lg border border-accent-green/20 hover:border-accent-green/50 transition-all group"
            >
              <div className="mb-6 text-accent-green text-4xl group-hover:scale-110 transition-transform">
                <FaQuoteLeft />
              </div>
              
              <p className="text-cream/80 text-lg mb-6 leading-relaxed">
                {testimonial.content}
              </p>

              <div className="flex items-center gap-2 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="text-accent-green" />
                ))}
              </div>

              <div>
                <h3 className="text-xl font-semibold text-accent-green mb-1">
                  {testimonial.name}
                </h3>
                <p className="text-cream/60">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Background Particles */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-accent-green rounded-full animate-pulse" />
          <div className="absolute top-1/3 right-1/4 w-3 h-3 bg-accent-green rounded-full animate-pulse delay-100" />
          <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-accent-green rounded-full animate-pulse delay-200" />
          <div className="absolute top-1/2 right-1/3 w-2 h-2 bg-accent-green rounded-full animate-pulse delay-300" />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
